import getResizedImage from './get-resized-image.js';

/**
 * Returns the native srcset format
 * @param {string} cropType - The resizedimgs "action" param. Can be "fit-in" or "crop".
 * @param {string} url - The resizedimgs url with placeholders.
 * @param {Object} srcSet - An object including the resolution and the image size.
 * @returns {(string|undefined)}
 */
var getResizedImageSrcSet = (cropType, url, srcSet) => {
  if (!srcSet) return undefined;

  return Object.keys(srcSet)
    .map(resolution => {
      const size = srcSet[resolution];
      const image = getResizedImage({ cropType, url, size });
      return [image, resolution].join(' ');
    })
    .join(',');
};

export { getResizedImageSrcSet as default };
//# sourceMappingURL=get-resized-image-src-set.js.map
